import '../custom/main.scss';
// import Splide from '@splidejs/splide';

// document.addEventListener('DOMContentLoaded', function () {
//   const mainSlider = document.getElementById('latest-watches-slider');

//   if (mainSlider) {
//     new Splide(mainSlider, {
//       type: 'loop',
//       perPage: 4,
//       perMove: 1,
//       padding: '3rem',
//       gap: '1.5rem',
//       pagination: false,
//       breakpoints: {
//         1200: {
//           perPage: 4,
//         },
//         992: {
//           perPage: 3,
//         },
//         768: {
//           perPage: 2,
//           gap: '1rem',
//         },
//         600: {
//           perPage: 1,
//           gap: '1rem',
//         },
//       },

//       classes: {
//         arrows: 'splide__arrows your-class-arrows',
//         arrow: 'splide__arrow your-class-arrow',
//         prev: 'splide__arrow--prev your-class-prev',
//         next: 'splide__arrow--next your-class-next',
//       },
//     }).mount();
//   }
// });

document.addEventListener('DOMContentLoaded', function () {});
